var _ellipse, _circle, _circle2, _circle3, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayFailed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 150,
    viewBox: "0 0 151 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.5,
    cy: 75,
    rx: 75.5,
    ry: 75,
    fill: "#C00707",
    fillOpacity: 0.07
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 65,
    fill: "#C00707",
    fillOpacity: 0.16
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 55,
    fill: "#C00707",
    fillOpacity: 0.16
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 75,
    r: 45,
    fill: "#C00707"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.5 77.8249L63.8625 89.4624C63.4271 89.8978 62.8729 90.1155 62.2 90.1155C61.5271 90.1155 60.9729 89.8978 60.5375 89.4624C60.1021 89.027 59.8844 88.4728 59.8844 87.7999C59.8844 87.127 60.1021 86.5728 60.5375 86.1374L72.175 74.4999L60.5375 62.8624C60.1021 62.427 59.8844 61.8728 59.8844 61.1999C59.8844 60.527 60.1021 59.9728 60.5375 59.5374C60.9729 59.102 61.5271 58.8843 62.2 58.8843C62.8729 58.8843 63.4271 59.102 63.8625 59.5374L75.5 71.1749L87.1375 59.5374C87.5729 59.102 88.1271 58.8843 88.8 58.8843C89.4729 58.8843 90.0271 59.102 90.4625 59.5374C90.8979 59.9728 91.1157 60.527 91.1157 61.1999C91.1157 61.8728 90.8979 62.427 90.4625 62.8624L78.825 74.4999L90.4625 86.1374C90.8979 86.5728 91.1157 87.127 91.1157 87.7999C91.1157 88.4728 90.8979 89.027 90.4625 89.4624C90.0271 89.8978 89.4729 90.1155 88.8 90.1155C88.1271 90.1155 87.5729 89.8978 87.1375 89.4624L75.5 77.8249Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayFailed);
export default __webpack_public_path__ + "static/media/PayFailed.8b9ba6c31dcff806ab2d3229ec41c98b.svg";
export { ForwardRef as ReactComponent };